import { use, Suspense, useState, useEffect } from "react";
import { CardComponentProps } from "@~/types/types";
import { SocialProofMessage } from "@JohnLewisPartnership/jl-design-system/dist/components/social-proof-message/SocialProofMessage";
import styles from "./SocialProofMessaging.module.scss";

function SocialProofMessagingContent({
  product,
}: Pick<CardComponentProps, "product">) {
  const messages = product.socialProofMessages
    ? use(product.socialProofMessages)
    : undefined;

  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <div
      data-component="pcl-SocialProofMessaging"
      className={styles.socialProofMessage}
    >
      <SocialProofMessage
        message={`${messages[0]?.title}`}
      ></SocialProofMessage>
    </div>
  );
}

export function SocialProofMessaging({
  product,
}: Pick<CardComponentProps, "product">) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(function markSocialProofAsMounted() {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <SocialProofMessagingContent product={product} />
    </Suspense>
  );
}
